import { useEffect } from "react";
import useActionLock from "../../hooks/useActionLock";
import {
  checkIfUnsubscribeAndSubscriptionAndUserInBackToFreePlan,
  checkIsSubscriptionExpired,
  checkIsTrialCancelled,
  LANGUAGE,
} from "../../config/constants";
import { updateSubscriptionData } from "../../redux/reducers/subscription/subscription.reducer";
import { connect } from "react-redux";
import { i18n } from "../../pages/private/languageSelector";

const PricingPlanDialog = ({
  showModal,
  onClose,
  text_one,
  text_two,
  text_three,
  secondaryButtonColor,
  setSelectedPlan,
  selectedPlan,
  subscriptionData,
  handleOpenChargeBillingDetails,
  updateSubscriptionData,
}) => {
  const [locked, runAction] = useActionLock();
  let newSelectedPlan;
  const handleSelectPlan = (e) => {
    newSelectedPlan = e.target.value;
    setSelectedPlan(newSelectedPlan);
    if (subscriptionData?.currentPlan?.status === "Expired") {
      if (newSelectedPlan) {
        localStorage.setItem("selectedPlan", newSelectedPlan);
      }
    }
  };

  useEffect(() => {
    if (
      subscriptionData?.currentPlan?.plan === "Monthly Subscription" ||
      subscriptionData?.currentPlan?.plan === "Yearly Subscription"
    ) {
      setSelectedPlan(subscriptionData?.currentPlan?.plan);
    }
  }, [subscriptionData, setSelectedPlan]);

  useEffect(() => {
    if (subscriptionData?.currentPlan?.status === "Expired") {
      if (selectedPlan) {
        localStorage.setItem("selectedPlan", selectedPlan);
      }
    }
  }, [selectedPlan, subscriptionData]);

  if (!showModal) return null;

  const handleOutsideClick = (e) => {
    if (e.target.id === "default-modal") {
      onClose();
      setSelectedPlan(null);
    }
  };

  const isUserInBackToFreePlanAfterUnSubscribe =
    checkIfUnsubscribeAndSubscriptionAndUserInBackToFreePlan(subscriptionData);

  const isUserInBackToFreePlanAfterTrialCancelled =
    checkIsTrialCancelled(subscriptionData);

  const seatsForLastSubscription =
    isUserInBackToFreePlanAfterUnSubscribe ||
      isUserInBackToFreePlanAfterTrialCancelled
      ? subscriptionData?.seats?.used
      : subscriptionData?.seats?.total;

  const seatPriceseatsForLastSubscription =
    selectedPlan === "Monthly Subscription" ? 79 : 790;

  const usedSeatCalculationseatsForLastSubscription =
    seatPriceseatsForLastSubscription * seatsForLastSubscription;

  const taxRateseatsForLastSubscription = (subscriptionData?.applyTax ? 0.15 : 0);

  const taxOnUsedSeatCalculationseatsForLastSubscription =
    usedSeatCalculationseatsForLastSubscription *
    taxRateseatsForLastSubscription;

  const totalAmountseatsForLastSubscription =
    usedSeatCalculationseatsForLastSubscription +
    taxOnUsedSeatCalculationseatsForLastSubscription;

  const updateSubscriptionDataForToAddLastSubscriptionDataUpdated = {
    lastSubscriptionData: {
      plan: selectedPlan,

      seats: seatsForLastSubscription,

      seatsPrice: Number(
        usedSeatCalculationseatsForLastSubscription.toFixed(2)
      ),

      taxes: Number(
        taxOnUsedSeatCalculationseatsForLastSubscription.toFixed(2)
      ),

      total: parseFloat(totalAmountseatsForLastSubscription.toFixed(2)),

      todaysTotal: 0,

      proratedCostPerSeat: Number(seatPriceseatsForLastSubscription.toFixed(2)),
    },
  };

  const handleConfirm = () => runAction(async () => {
    const isTrialOrExpired =
      subscriptionData?.currentPlan?.plan === "Trial" ||
      subscriptionData?.currentPlan?.plan === "Trial is running" ||
      subscriptionData?.currentPlan?.status === "Expired";

    const isEligibleForUpdate =
      subscriptionData?.subscriptionInfo?.isSubscribed === false &&
      subscriptionData?.subscriptionInfo?.isSubscribedExpired === false &&
      subscriptionData?.subscriptionInfo?.isUnsubscribed === false;

    const isTrialCancelled = checkIsTrialCancelled(subscriptionData);

    const isSubscriptionExpired = checkIsSubscriptionExpired(subscriptionData);

    if (
      (isTrialOrExpired && isEligibleForUpdate) ||
      isTrialCancelled ||
      isSubscriptionExpired
    ) {
      if (subscriptionData?.id) {
        try {
          await updateSubscriptionData(
            subscriptionData.id,
            updateSubscriptionDataForToAddLastSubscriptionDataUpdated,
            "Update"
          );
        } catch (error) {
          console.error("Error updating subscription data:", error);
        }
      }
    }
    handleOpenChargeBillingDetails();
  });

  return (
    <div
      id="default-modal"
      onClick={handleOutsideClick}
      tabIndex="-1"
      aria-hidden="true"
      className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50"
    >
      <div className="bg-white rounded-lg shadow-lg w-full max-w-xs p-6">
        <div className="mb-4 flex items-start">
          <h3 className="text-base font-semibold">
            {i18n("Modals.SelectYourPricingPlan")}
          </h3>
        </div>
        <div>
          <form className="space-y-4">
            <div className="flex items-center gap-2">
              <input
                checked={selectedPlan === "Monthly Subscription"}
                className="w-[15px] h-[15px] cursor-pointer text-colPrimary border-colPrimary outline-none focus:ring-2 focus:ring-colPrimary"
                type="radio"
                id="monthly-subscription"
                value="Monthly Subscription"
                onChange={handleSelectPlan}
              />
              <label
                htmlFor="monthly-subscription"
                className="text-gray-700 text-sm whitespace-nowrap mt-1 cursor-pointer focus:border-none focus:outline-none"
              >
                {i18n("Subscriptions.Month")} (
                {i18n("Subscriptions.SARPerseatPerMonth")})
              </label>
            </div>
            <div className="flex items-center gap-2">
              <input
                checked={selectedPlan === "Yearly Subscription"}
                className="w-[15px] h-[15px] cursor-pointer text-colPrimary border-colPrimary outline-none focus:outline-none focus:ring-2 focus:ring-colPrimary"
                type="radio"
                id="yearly-subscription"
                value="Yearly Subscription"
                onChange={handleSelectPlan}
              />
              <label
                htmlFor="yearly-subscription"
                className="text-gray-700 text-sm whitespace-nowrap mt-1 cursor-pointer focus:border-none focus:outline-none"
              >
                {i18n("Subscriptions.Annual")} (
                {i18n("Subscriptions.SARPerseatPerYear")})
              </label>
            </div>
          </form>
          <div className="text-gray-500 mt-3 text-sm flex flex-col items-start">
            <p>{text_one}</p>
            <p className="mt-3 text-start">{text_two}</p>
            <p>{text_three}</p>
          </div>
        </div>
        <div className={`mt-6 flex justify-between items-center px-8`}>
          <button
            className="text-sm font-semibold border-none focus:outline-none focus:border-none text-gray-400"
            style={{ color: secondaryButtonColor }}
            onClick={() => {
              onClose();
              setSelectedPlan(null);
            }}
          >
            {i18n("Modals.CANCEL")}
          </button>
          <button
            className={`text-sm font-semibold border-none focus:outline-none focus:border-none ${selectedPlan ? "text-colPrimary" : "text-[#BDBDBD]"
              }`}
            onClick={handleConfirm}
            disabled={locked || !selectedPlan}
          >
            {i18n("Modals.CONTINUE")}
          </button>
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = () => ({});

const mapDispatchToProps = {
  updateSubscriptionData,
};

export default connect(mapStateToProps, mapDispatchToProps)(PricingPlanDialog);
